import React from 'react';
import {LayoutSidebar} from '../../../Layout';
import {Spinner} from '../../Spinner';
import {AccountsV2} from './AccountsV2';

/**
 * La ruta `/agency/ad-accounts` en la 2.1: el marco de siempre (`LayoutSidebar` ya decide si dibuja
 * el riel nuevo) y la pantalla nueva adentro.
 *
 * Con `pending`, todavía no se sabe qué versión de la UI ve el usuario (`useUiVersion().loaded`):
 * un spinner, nunca un flash de la pantalla clásica (contrato, «Para las tres»).
 */
export function AccountsV2Page({location, navigate, pending = false}) {
    return (
        <div className="app-content">
            <LayoutSidebar/>
            {pending
                ? <section className="section-content"><div className="box-loader"><Spinner color="positive"/></div></section>
                : <AccountsV2 location={location} navigate={navigate}/>}
        </div>
    );
}

export default AccountsV2Page;
